import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css';
import logo from '../assets/logo.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo">
            <img src={logo} alt="Egypt International Exhibition logo" />
          </div>
          <div>
            <strong>Egypt Int'l Exhibition</strong>
            <span>Textile Machinery</span>
          </div>
          <p>
            The premier platform for textile machinery, garment technology, and
            industrial sourcing in the Middle East and Africa.
          </p>
        </div>

        <div className="footer-column">
          <h3>Quick Links</h3>
          <Link to="/">Home</Link>
          <Link to="/exhibitors">Exhibitors</Link>
          <Link to="/schedule">Schedule</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="footer-column">
          <h3>For Visitors</h3>
          <Link to="/tickets">Book Ticket</Link>
          <Link to="/schedule">Event Schedule</Link>
          <Link to="/exhibitors">Exhibition Map</Link>
          <Link to="/contact">FAQs</Link>
        </div>

        <div className="footer-column">
          <h3>Contact</h3>
          <a href="mailto:info@egypttextileexpo.com">info@egypttextileexpo.com</a>
          <a href="tel:+20212345678">+20 2 1234 5678</a>
          <span>Cairo, Egypt</span>
          <span>LinkedIn / Twitter</span>
        </div>
      </div>

      <div className="footer-bottom">
        <span>(c) 2026 Egypt International Exhibition for Garment and Textile Machinery.</span>
        <span>Built for industry leaders.</span>
      </div>
    </footer>
  );
};

export default Footer;
